import $ from 'jquery';

export default {
  init () {
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
    this.$links = $('.nav-link')
    this.$childs = $('.nav-childs')
    this.$navChilds = $(`.nav-childs-arrow`);
    this.$childsContainer = $('.nav-childs-container');
    $('.nav-item').on('mouseover', this.open)
    this.$childsContainer.on('mouseleave', this.close)
    $('.nav-top-container').on('mouseleave', this.close)
    $(`.hamburger, .ionicons-close`).on('click', this.toggleMenu)
    this.$mobile = $('.header-mobile-main')
    $('.faq-group-overlay').css({'display': 'none'})
    var stickyOffset = $('.sticky').offset().top;
    if ($(window).width() <= 992) {
      stickyOffset = 40;
    }
    $(window).scroll(function() {
      var sticky = $('.sticky'),
          scroll = $(window).scrollTop();

      if (scroll >= stickyOffset) {
        sticky.addClass('fixed');
        $('.page-content').addClass('fixed')
        $('.suggestion-list').addClass('fixed')
        $('.faq-group-overlay').css({'display': 'block'})
      }
      else {
        sticky.removeClass('fixed');
        $('.page-content').removeClass('fixed')
        $('.suggestion-list').removeClass('fixed')
        $('.faq-group-overlay').css({'display': 'none'})
      }
    });

    $('.nav-link--mobile').on('click', function () {
      $(this).toggleClass('show')
      $('.nav-childs-container--mobile').toggleClass('show')
    });


  },
  open (e) {
    this.close()
    const $parent = $(e.currentTarget)
    const index = $parent.data('index')
    if (index === '') return
    const $target = $(`.nav-childs-arrow[data-index=${index}]`)
    this.$childsContainer.addClass('show')
    $target.addClass('show');
    $parent.find('.nav-link').addClass('show')
  },
  close () {
    this.$links.removeClass('show')
    this.$childsContainer.removeClass('show')
    this.$childs.removeClass('show')
    this.$navChilds.removeClass('show')
    this.$childs.parent().parent().find('.nav-link').removeClass('show')
  },

  toggleMenu () {
    this.$mobile.toggleClass('closed')
  },

};
